import { GiftProductType } from "./giftProductType";
import { IntegrationType } from "./integrationType";

export interface GiftProduct {
  id?: string;
  type: GiftProductType;

  // Integration type
  integrationType?: IntegrationType | null;

  // Virtual Product fields
  productName?: string;
  productDescription?: string;
  productValue?: number;
  productImagePath?: string;
  productImageFile?: File;
  discountPercentage?: number; // percentual de desconto
  saleProductIds?: any[]; // lista de sale_product completos (com id e name)
  // Recompensa em dinheiro: valor de face em R$. Preenchido, o produto virtual vira
  // "Cashback" e o cupom nasce com is_cashback + partner_value.
  cashValue?: number | null;

  // Existing Product fields
  productId?: string;

  // Link to existing Discount (type='reward') for fuel discount products
  discountId?: string | null;

  // Bolão da Copa: obrigatório quando type=prediction_ticket
  bolaoId?: string | null;
  bolaoName?: string | null; // display-only (preenchido após selecionar)

  // Número da Sorte: obrigatórios quando type=drawing_number.
  // Só sorteio com regras via Clube de Vantagens (isClubDriven) entra aqui.
  drawingId?: string | null;
  drawingName?: string | null; // display-only (preenchido após selecionar)
  luckyNumberAmount?: number | null; // quantos números a conquista concede (mín. 1)

  // Roleta da Sorte: obrigatórios quando type=spin_ticket.
  // A conquista não gera cupom — gera N giros na roleta vinculada.
  roletaId?: string | null;
  roletaName?: string | null; // display-only (preenchido após selecionar)
  spinAmount?: number | null; // quantos giros a conquista concede (mín. 1)
}

export class GiftProductHelper {
  static createGiftProduct(value: Partial<GiftProduct>): GiftProduct {
    return {
      id: value.id || crypto.randomUUID(),
      type: value.type!,
      integrationType: value.integrationType || null,
      productName: value.productName,
      productDescription: value.productDescription,
      productValue: value.productValue,
      productImagePath: value.productImagePath,
      productImageFile: value.productImageFile,
      discountPercentage: value.discountPercentage,
      saleProductIds: value.saleProductIds,
      cashValue: value.cashValue ?? null,
      productId: value.productId,
      discountId: value.discountId || null,
      bolaoId: value.bolaoId || null,
      bolaoName: value.bolaoName || null,
      drawingId: value.drawingId || null,
      drawingName: value.drawingName || null,
      luckyNumberAmount: value.luckyNumberAmount || null,
      roletaId: value.roletaId || null,
      roletaName: value.roletaName || null,
      spinAmount: value.spinAmount || null,
    };
  }
}
